import { PlantBuilderFormStep } from '@/types/forms/formSteps/plantBuilderFormStep';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import { toggleRequiredValidator } from '@/utilities/toggleRequiredValidator';
import { contentServices } from '@/services/contentService';
import { authService } from '@/services/authService';

function getAvailableInstallerCount(): number {
    if (authService.deaAdditionalUserData?.isInstaller) {
        return authService.deaAdditionalUserData.installers.reduce(
            (sum, installer) => sum + installer.companies.length,
            0,
        );
    }

    return (
        contentServices.form.content?.serviceDrivenContent.installersContent
            ?.length ?? 0
    );
}

export const plantBuilderRules = async (
    formStep: { model: PlantBuilderFormStep; formModel: ApplicationForm } & Vue,
): Promise<void> => {
    const hasInstallers = getAvailableInstallerCount() > 0;

    // Without any installers to choose from the select and the "not in list"
    // checkbox are pointless: hide them and behave as if "not in list" is checked.
    if (!hasInstallers) {
        formStep.model.installerNotListed.value = true;
    }
    formStep.model.installer.hidden = !hasInstallers;
    formStep.model.installerNotListed.hidden = !hasInstallers;

    const installerNotListed = formStep.model.installerNotListed.value ?? false;
    formStep.model.installer.userChangeable = !installerNotListed;
    formStep.model.companyName.userChangeable = installerNotListed;
    formStep.model.builderName.firstName.userChangeable = installerNotListed;
    formStep.model.builderName.lastName.userChangeable = installerNotListed;
    formStep.model.country.userChangeable = installerNotListed;
    formStep.model.zipAndCity.zip.userChangeable = installerNotListed;
    formStep.model.zipAndCity.city.userChangeable = installerNotListed;
    formStep.model.streetAndHousenumber.street.userChangeable = installerNotListed;
    formStep.model.streetAndHousenumber.housenumber.userChangeable = installerNotListed;
    formStep.model.email.userChangeable = installerNotListed;
    formStep.model.phoneNumber1.userChangeable = installerNotListed;
    formStep.model.phoneNumber2.userChangeable = installerNotListed;

    toggleRequiredValidator(formStep.model.installer, !installerNotListed);
};
